import { render, staticRenderFns } from "./EnforcementTransactionList.vue?vue&type=template&id=6c4b013b"
import script from "./EnforcementTransactionList.vue?vue&type=script&lang=js"
export * from "./EnforcementTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports